function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function wait(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function animateFlyer(flyer, from, to, duration) {
  return new Promise((resolve) => {
    const start = performance.now();
    const arcHeight = Math.min(120, Math.abs(from.y - to.y) * 0.6 + 40);

    function frame(now) {
      const t = Math.min(1, (now - start) / duration);
      const ease = 1 - Math.pow(1 - t, 3);
      const x = from.x + (to.x - from.x) * ease;
      const baseY = from.y + (to.y - from.y) * ease;
      const y = baseY - Math.sin(Math.PI * ease) * arcHeight;
      flyer.style.left = `${x}px`;
      flyer.style.top = `${y}px`;
      if (t < 1) {
        requestAnimationFrame(frame);
      } else {
        resolve();
      }
    }

    flyer.style.left = `${from.x}px`;
    flyer.style.top = `${from.y}px`;
    requestAnimationFrame(frame);
  });
}

class GumballEntry {
  constructor() {
    this.trigger = document.querySelector('[data-gumball-entry-trigger]');
    this.overlay = document.querySelector('[data-gumball-entry-overlay]');
    if (!this.trigger || !this.overlay) return;

    this.url = this.trigger.dataset.countdownUrl || '/pages/new-drop-countdown';
    this.flyer = this.overlay.querySelector('[data-gumball-flyer]');
    this.bubble = this.overlay.querySelector('[data-gumball-bubble]');
    this.mouth = this.overlay.querySelector('[data-gumball-mouth]');
    this.playing = false;

    this.trigger.addEventListener('click', () => this.onTrigger());
  }

  cleanup() {
    document.body.classList.remove('gumball-entry-locked');
    this.overlay.hidden = true;
    this.overlay.setAttribute('aria-hidden', 'true');
  }

  navigate() {
    this.cleanup();
    window.location.assign(this.url);
  }

  async onTrigger() {
    if (this.playing) return;
    if (prefersReducedMotion()) {
      this.navigate();
      return;
    }
    await this.playSequence();
  }

  async playSequence() {
    this.playing = true;
    document.body.classList.add('gumball-entry-locked');
    this.overlay.hidden = false;
    this.overlay.setAttribute('aria-hidden', 'false');

    // Fallback: if anything stalls, navigate after 4s
    const fallback = setTimeout(() => this.navigate(), 4000);

    const triggerRect = this.trigger.getBoundingClientRect();
    const from = {
      x: triggerRect.left + triggerRect.width / 2,
      y: triggerRect.top + triggerRect.height / 2,
    };
    const to = {
      x: window.innerWidth / 2,
      y: window.innerHeight * 0.88,
    };

    const color = getComputedStyle(this.trigger).getPropertyValue('--gumball-entry-color').trim();
    if (color) this.flyer.style.setProperty('--gumball-entry-color', color);

    this.flyer.hidden = false;
    this.overlay.classList.remove('is-mouth-visible');
    this.bubble.hidden = true;
    this.bubble.classList.remove('is-growing', 'is-popping');

    await animateFlyer(this.flyer, from, to, 600);
    this.flyer.hidden = true;

    this.overlay.classList.add('is-mouth-visible');
    await wait(300);

    this.bubble.hidden = false;
    this.bubble.classList.add('is-growing');
    await wait(900);

    this.bubble.classList.remove('is-growing');
    this.bubble.classList.add('is-popping');
    await wait(400);

    clearTimeout(fallback);
    this.navigate();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new GumballEntry();
});
